import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Dumbbell, Sparkles } from "lucide-react";

export const EmptyRoutineState = () => {
  const navigate = useNavigate();

  const handleStartRoutines = () => {
    navigate("/rutina?tutorial=true");
  };

  return (
    <div className="glass animate-fade-in p-8 text-center">
      <div className="flex justify-center mb-6">
        <div className="relative">
          <Dumbbell className="h-16 w-16 text-primary" />
          <Sparkles className="h-6 w-6 text-accent absolute -top-1 -right-1 animate-pulse" />
        </div>
      </div>
      
      <h2 className="text-2xl font-heading font-bold text-primary mb-4">
        ¡Comienza tu viaje fitness!
      </h2>
      
      <p className="text-muted-foreground mb-6 max-w-md mx-auto">
        No tienes rutinas creadas aún. Te ayudamos a crear tu primer plan de entrenamiento personalizado.
      </p>
      
      <Button 
        onClick={handleStartRoutines}
        className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium px-4 py-2 sm:px-8 sm:py-3 text-sm sm:text-lg animate-scale-in"
      >
        <Dumbbell className="mr-2 h-4 w-4 sm:h-5 sm:w-5" />
        <span className="whitespace-normal sm:whitespace-nowrap">Comienza a crear rutinas</span>
      </Button>
    </div>
  );
};